import { PesadosBrasilStorage } from './../../services/pesados-brasil/pesados-brasil.storage';
import { LoginStorage } from './../../login/login.storage';
import { AgenteService } from './../../services/pesados-brasil/agente.service';
import { AgenteEndereco } from './../../services/pesados-brasil/agente-endereco.interface';
import { finalize, take } from 'rxjs/operators';
import { CepService } from './../../services/cep/cep.service';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-ficha-cep-cliente',
  templateUrl: './ficha-cep-cliente.component.html',
  styleUrls: ['./ficha-cep-cliente.component.css'],
})
export class FichaCepClienteComponent implements OnInit {
  @Output() cadastrarFichaEventEmitter: EventEmitter<any> =
    new EventEmitter<any>();
  public cepAgente: string = '';
  public isBuscandoCep: boolean = false;
  public endereco;
  public agenteEndereco: AgenteEndereco;
  public cepErrorStatus: string = '';
  public originador;
  public msgText: string;
  public icon: string;
  public colorText: string;
  public enderecoTotal;
  public cepErroMessage: string;
  public agentDestinationErrorMessage: string;

  constructor(
    private cepService: CepService,
    private agenteService: AgenteService,
    private loginStorage: LoginStorage,
    private pesadosBrasilStorage: PesadosBrasilStorage,
  ) {}

  ngOnInit() {
    this.originador = this.loginStorage.originator;
  }

  onCepExit() {
    if (this.cepAgente) {
      this.isBuscandoCep = true;
      this.cepService
        .getEnderecoByCep(this.cepAgente.replace('-', ''))
        .pipe(
          finalize(() => (this.isBuscandoCep = false)),
          take(1),
        )
        .subscribe({
          next: (res) => {
            this.enderecoTotal = res;
            this.handleFindEnderecoCep(res.enderecos[0]);
            this.getCEPAgente();
            this.cepErroMessage = undefined;
          },
          error: (err) => {
            this.cepErroMessage =
              err.error && err.error.message ? err.error.message : '';
            this.endereco = undefined;
            this.agenteEndereco = undefined;
          },
        });
    }
  }

  private handleFindEnderecoCep(res) {
    this.endereco = {};
    if (res.logradouro) {
      this.endereco.endereco = res.logradouro;
    }
    if (res.uf) {
      this.endereco.uf = res.uf;
    }
    if (res.cidade) {
      this.endereco.cidade = res.cidade;
    }
    if (res.bairro) {
      this.endereco.bairro = res.bairro;
    }
    if (res.numero) {
      this.endereco.numero = res.numero;
    }
    if (res.cep) {
      this.endereco.cep = res.cep;
    }
  }

  getCEPAgente() {
    if (this.cepAgente) {
      this.isBuscandoCep = true;
      this.agenteEndereco = null;
      this.cepErrorStatus = '';
      this.agenteService
        .getEnderecoAgentePorCep(
          this.cepAgente.replace('-', ''),
          this.originador.typesOrigination[0].code,
        )
        .pipe(
          finalize(() => (this.isBuscandoCep = false)),
          take(1),
        )
        .subscribe({
          next: (res) => {
            this.agenteEndereco = res;
            this.cepErrorStatus = 'OK';
          },
          error: (error) => {
            this.cepErrorStatus = 'ERRO';
            this.agentDestinationErrorMessage =
              error.error?.messages?.[0] ??
              'CEP indísponível! Não será possível atender um cliente dessa região.';
          },
        });
    }
  }

  cadastrarProposta() {
    this.pesadosBrasilStorage.registerAgenteEndereco(this.agenteEndereco);
    this.pesadosBrasilStorage.registerEnderecoTotal(this.enderecoTotal);
    this.cadastrarFichaEventEmitter.emit();
  }
}
